<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation @onValidate="submit" novalidate v-av-analytics-form-submit="{ elementText: btnText }">
      <h2>{{ $t('message.eCommerceV2.contactDetailsFormHeading') }}</h2>
      <p v-if="!isFinanceFlow">{{ $t('message.eCommerceV2.contactDetailsFormMsg') }}</p>
      <div class="row form-row mt-3 mt-sm-4">
        <div class="col-sm-4">
          <mobialis-text-input-with-validation
            class="input-width-180"
            rules="required|length:10"
            :label="$t('message.common.phoneNumber')"
            v-model="phoneNumber"
            vid="phoneNumber"
            placeholder="(   )"
            mask-type="phoneNumber"
            type="tel"
            data-cy="phoneNumber"
          ></mobialis-text-input-with-validation>
        </div>
        <div class="col-sm-8">
          <mobialis-text-input-with-validation
            class="mb-0"
            rules="required|email"
            :label="$t('message.common.emailAddress')"
            v-model="emailAddress"
            vid="emailAddress"
            data-cy="emailAddress"
            type="email"
          ></mobialis-text-input-with-validation>
        </div>
      </div>
      <InfoCard v-if="!isFinanceFlow" class="font-weight-bold text-center mt-5">
        <img class="mr-2 mb-1" :src="require('@/assets/shield-check-blue.svg')" alt="" width="16px" height="16px" />
        {{ $t('message.eCommerceV2.notAffectCredit') }}
      </InfoCard>
      <mobialis-check-box-with-validation
        v-else
        class="mt-4 pt-2"
        rules="required:true"
        :label="
          $t('message.eCommerceV2.finance.tandc', {
            termsLink: $t('message.eCommerceV2.finance.termsLink'),
            dealerName: businessName,
          })
        "
        vid="tandc"
        id="tandc"
        data-cy="tAndC"
        v-model="tandc"
      >
      </mobialis-check-box-with-validation>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{ btnText }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import { enumMixin } from '@/mixins';
import InfoCard from '@/components/InfoCard.vue';
import log from '@/services/log';

export default {
  name: 'ContactDetailsForm',
  mixins: [enumMixin],
  components: {
    InfoCard,
  },
  data() {
    return {
      phoneNumber: cloneDeep(this.$store.state.user.phoneNumber),
      emailAddress: cloneDeep(this.$store.state.user.emailAddress),
      tandc: false,
    };
  },
  computed: {
    ...mapGetters({
      businessName: 'business/getBusinessName',
      getThisIsAmerica: 'business/getThisIsAmerica',
      getCurrentProduct: 'getCurrentProduct',
    }),
    isFinanceFlow() {
      return this.currentSubFlow === 'finance';
    },
    btnText() {
      return this.isFinanceFlow
        ? this.$t('message.eCommerceV2.finance.submitApplication')
        : this.$t('message.common.continue');
    },
    isEcomV2() {
      return this.getCurrentProduct === this.enums.AVRProducts.ECOMV2;
    },
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_PHONE_NUMBER', this.phoneNumber);
      this.$store.commit('user/SET_EMAIL_ADDRESS', this.emailAddress);

      // If this is the finance flow that means the user
      // hasn't gone though the credit flow successfully
      // so we won't have a lead (most likely) or credit score yet
      if (this.isFinanceFlow) {
        this.$store.commit('SET_LOADING', true);
        this.createLead();
      } else {
        this.$router.push({ path: this.getNextRoutePath() });
      }
    },
    async createLead() {
      const payload = this.isEcomV2 ? { subType: this.enums.SubType.ECOMV2 } : null;
      try {
        await this.$store.dispatch('lead/createLead', payload);
        await this.$store.dispatch('lead/createFinanceApplication');
        // Get regional credit score just so the dealer has more info
        // Canada only
        if (!this.getThisIsAmerica) {
          this.getRegionalCredit();
        } else {
          this.nextPage();
        }
      } catch (err) {
        this.$store.commit('SET_LOADING', false);
        log('Error in contact details form create lead', err);
        this.$router.push('error');
      }
    },
    async getRegionalCredit() {
      try {
        await this.$store.dispatch('credit/getRegionalCreditScore');
      } catch (err) {
        // No need to go to error page, just log error
        log('Error in getRegionalCreditScore on contact form finance flow', err);
      } finally {
        this.nextPage();
      }
    },
    nextPage() {
      this.$store.commit('SET_LOADING', false);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
